var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "h-100 d-flex flex-column" }, [
    _c(
      "div",
      {
        staticClass: "sidebar-item",
        class: { disabled: _vm.isActive === false },
      },
      [
        _c(
          "div",
          {
            staticClass:
              "d-flex align-items-center gap-20 justify-content-between",
          },
          [
            _c("div", { staticClass: "d-flex gap-20 align-items-center" }, [
              _c(
                "span",
                {
                  staticClass: "main-number",
                  class: {
                    disabled: _vm.isActive === false,
                    done: _vm.isActive === false,
                  },
                },
                [_vm._v("1")]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "font-size-125" }, [
                _vm._v(_vm._s(_vm._f("trans")("Upload your image"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", {
              on: {
                click: function ($event) {
                  _vm.item_open = !_vm.item_open
                },
              },
            }),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "sidebar-item d-flex flex-1" }, [
      _c("div", { staticClass: "alert alert-info" }, [
        _vm._v("Upload the image you want to edit using AI Magic Editor"),
      ]),
      _vm._v(" "),
      _vm.item_open === true && _vm.isActive === true
        ? _c("div", { staticClass: "h-100 flex-1" }, [
            _c(
              "div",
              { staticClass: "upload-box-item h-100" },
              [_c("upload-box")],
              1
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }